import * as angular from 'angular';
import './company-details.scss';
import { OnInit, Component, Input } from 'ng-metadata/core';
import { MediaSourceDocument, MediaSourceSocialProfile } from '../media-source-document.model';

/**
 * @ngdoc directive
 * @name mwMediaSourceDocumentDetailsComponent
 * @module mw.components.contentDocuments
 *
 * @param {object} [source] - The content document
 *
 * @description
 * `<mw-media-source-document-details>` is a component used to display a single media source document.
 *
 *
 * @usage
 * <hljs hljs-language="html">
 * </hljs>
 */

const template = `
    <div class="mw-media-source-document-details__left-fill"></div>
    <div class="mw-media-source-document-details__content">
    <div class="mw-media-source-document-details__summary"
        ng-if="$ctrl.source.detail.summary || $ctrl.shortSummary">
        <span class="mw-media-source-document-details__header"
        translate>mw-media-source-document__company-details--summary
        </span>
        <span class="mw-media-source-document-details__text" mw-truncate="150">
            {{$ctrl.source.detail.summary}}
        </span>
    </div>
    <div class="mw-media-source-document-details__contact"
        ng-if="$ctrl.source.detail.primaryPhone || $ctrl.source.detail.primaryEmail">
        <span class="mw-media-source-document-details__header"
        translate>mw-media-source-document__company-details--contact
        </span>
        <div class="mw-media-source-document-details__phone"
        ng-if="$ctrl.source.detail.primaryPhone">
        <md-icon md-svg-icon="hardware:ic_smartphone_24px"></md-icon>
        <span class="mw-media-source-document-details__sub-header"
            translate>mw-media-source-document__company-details--work-phone
        </span>
        <br>
        <span class="mw-media-source-document-details__text">
            {{$ctrl.source.detail.primaryPhone.number}}
        </span>
        </div>
        <div class="mw-media-source-document-details__email"
        ng-if="$ctrl.source.detail.primaryEmail">
        <md-icon md-svg-icon="communication:ic_email_24px"></md-icon>
        <span class="mw-media-source-document-details__sub-header"
            translate>mw-media-source-document__company-details--work-email
        </span>
        <br>
        <a class="mw-media-source-document-details__text"
            href="mailto:{{$ctrl.source.detail.primaryEmail.address}}">
            {{$ctrl.source.detail.primaryEmail.address}}
        </a>
        </div>
    </div>
    <div class="mw-media-source-document-details__social"
        ng-if="$ctrl.socialProfiles.length > 0">
        <span class="mw-media-source-document-details__header"
        translate>mw-media-source-document__company-details--social-profiles
        </span>
        <md-icon
        ng-repeat="profile in $ctrl.socialProfiles"
        class="mw-media-source-document__company-details--social-profiles-{{profile.type}}"
        ng-click="$ctrl.handleGoToProfile(profile.url)"
        md-svg-icon="{{profile.icon}}">
        </md-icon>
    </div>
    </div>
`;

@Component({
    selector: 'mw-media-source-document-details',
    template: template
})
export class MediaSourceDocumentDetailsComponent implements OnInit {
    @Input('<') source: MediaSourceDocument;

    private shortSummary: string = '';
    private showMore: boolean = false;
    private socialProfiles: MediaSourceSocialProfile[];
    private iconMap: { [type: string]: string } = {
        facebook: 'meltwater:facebook',
        linked_in: 'meltwater:linkedin',
        twitter: 'meltwater:twitter',
        googleplus: 'meltwater:gplus',
        instagram: 'meltwater:instagram',
        pinterest: 'meltwater:pinterest',
        youtube: 'meltwater:youtube',
        xing: 'meltwater:xing',
    };

    ngOnInit() {
        this.socialProfiles = this.source.detail.socialProfiles.map(s => ({
            ...s,
            icon: this.iconMap[s.type],
        }));
    }

    handleToggleShowMore() {
        this.showMore = !this.showMore
    }

    handleGoToProfile(url: string) {
        window.open(url, '_blank')
    }
}


// WEBPACK FOOTER //
// ./src/lib/components/content-documents/media-source-document/company-details/company-details.component.ts